import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { UserId } from '@models/UserProfile';
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { ApiService } from '../../api.service';

@Component({
  selector: 'app-user-id-autocomplete',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatAutocompleteModule,
    ReactiveFormsModule
  ],
  templateUrl: './user-id-autocomplete.component.html',
  styleUrl: './user-id-autocomplete.component.scss'
})
export class UserIdAutocompleteComponent {
  @ViewChild('input') input: ElementRef<HTMLInputElement> | undefined;
  myControl = new FormControl('');
  @Input() exclude: UserId[] = [];
  @Output() userIdChanged = new EventEmitter<UserId>();
  userId: UserId = "";
  options: UserId[] = [];
  filteredOptions: string[] = [];

  constructor(private api: ApiService) {
    this.api.getUserIds()
      .then((value: string[]) => {
        this.options = value.filter((u) => this.exclude.indexOf(u) == -1);
        this.filteredOptions = this.options.slice();
      });
  }

  optionSelected(event: MatAutocompleteSelectedEvent) {
    this.userIdChanged.emit(event.option.value);
  }

  filter(): void {
    if (this.input) {
      const filterValue = this.input.nativeElement.value.toLowerCase();
      this.filteredOptions = this.options.filter(o => o.toLowerCase().includes(filterValue));
    }
  }

}
